import React from 'react';
import { LanguageProvider } from './LanguageContext';
import { BrowserRouter, Route } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import NotesMenu from './NotesMenu';
import Note from './Note';
import BiseccionApp from './BiseccionApp';
import NewtonApp from './NewtonApp';
import VrpApp from './VrpApp';
import About from './About';
import Footer from './Footer';
import WebAPIDescription from './projects/WebAPIDescription';
import covidDescription from './projects/covidDescription';
import dogCEODescription from './projects/dogCEODescription';
import sesionaDescription from './projects/sesionaDescription';

const App = () => {

    return (
        <LanguageProvider>
        <div >
            <BrowserRouter>
                <div className="ui fluid container" style={{ width: '95%', margin: '0 auto' }}>
                    <Header />
                    <Route path="/" exact component={Home} />
                    <Route path="/about" exact component={About} />
                    <Route path="/rn" exact component={NotesMenu} />
                    <Route path="/interiorpoint" exact><Note name="interior_point" /></Route>
                    <Route path="/biseccion" exact component={BiseccionApp} />
                    <Route path="/newton" exact component={NewtonApp} />
                    <Route path="/tsp" exact component={VrpApp} />
                    <Route path="/webapiInfo" exact component={WebAPIDescription} />
                    <Route path="/covidInfo" exact component={covidDescription} />
                    <Route path="/dogCeoInfo" exact component={dogCEODescription} />
                    <Route path="/sesionaInfo" exact component={sesionaDescription} />
                    <Footer />
                </div>
            </BrowserRouter>
        </div>
        </LanguageProvider>

    );
}

export default App;